export default __webpack_public_path__ + "static/media/concentrationInverse.e357eed1.mp3";